import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Button, Typography, Paper, IconButton } from "@material-ui/core";
import useStyles from "../../styles/accessManagementStyle";
import { url } from "../../apis/apiSetup";
import "../../css/dataTable.css";
import { useTranslation } from "../../langs/useTranslation";
import * as localforage from "localforage";
import * as $ from "jquery";
import "datatables.net";
import "datetime-moment";
import {
  DeleteOutlined,
  EditOutlined,
  ReplayOutlined,
  AddBox,
  VisibilityOutlined
} from "@material-ui/icons";
import CreateRoleDialog from "./CreateRoleDialog";
// import RemoveRoleDialog from "./RemoveRoleDialog";
import { language } from "../../helpers/datatableSetting";
import modalConfirm from "../Modal/modalConfirm";
import { deleteRoleAPI } from "../../apis/deleteRoleAPI";
import { toast } from "@/helpers/toast";
import HasPermission from "../commons/HasPermission";
import { errorHandling } from "../../helpers/errorHandling";
import { ReactRender } from "../ReactRender";

const RoleManagementTable = ({ companyId }) => {
  const classes = useStyles();
  const { t } = useTranslation("accessManagement");
  //   const [open, setOpen] = useState(false);
  //   const [roleId, setRoleId] = useState();
  //   const [roleName, setRolenName] = useState();

  const handleRemoveRoleDialogClickOpen = (roleId, roleName) => {
    // setOpen(true);
    // setRoleId(roleId);
    // setRolenName(roleName);
    modalConfirm({
      title: t({ defaultMessage: "删除角色" }),
      content: t({ defaultMessage: "是否确定删除？" }),
      onConfirm: async () => {
        await deleteRoleAPI(roleId, companyId);
        toast.success(t({ defaultMessage: "删除成功" }));
        table();
      }
    });
  };

  //   const handleRemoveRoleDialogClose = () => {
  //     setOpen(false);
  //     table();
  //   };

  const table = async () => {
    const token = await localforage.getItem("token");
    const $table = $("#role-management-table").DataTable({
      processing: true,
      language: language(t),
      searching: true,
      filter: false,
      deferRender: true,
      info: false,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 15,
      ordering: false,
      order: [[0, "asc"]],
      ajax: {
        url: `${url}/api/v1/roles`,
        type: "GET",
        dataSrc: json => {
          const pageNum = $table.page();
          if (pageNum === 0) {
            return json.roles
              .map(role => ({ ...role, isSystem: true }))
              .concat(json.companyRoles);
          } else {
            return json.companyRoles;
          }
        },
        data: {
          page: 1,
          company_id: companyId
        },
        beforeSend: request => {
          request.setRequestHeader("Authorization", "Bearer " + token);
          request.setRequestHeader("Accept", "application/json");
        },
        error: (xhr, status, error) => {
          errorHandling(error);
        }
      },
      columns: [
        {
          data: "name",
          name: "data.name",
          title: `${t("table.roleTitle")}`,
          searchable: true,
          createdCell: (td, data) => {
            ReactRender(<Typography variant="body1">{data}</Typography>, td);
          }
        },
        {
          data: "id",
          name: "data.id",
          title: `${t("table.actionTitle")}`,
          searchable: true,
          createdCell: (td, data, rowData) => {
            if (rowData.isSystem) {
              ReactRender(
                <div>
                  <Button
                    href={`/permission-management/${rowData.name}/${data}/${companyId}`}
                    startIcon={<VisibilityOutlined />}
                  >
                    {t({ defaultMessage: "查看权限" })}
                  </Button>
                </div>,
                td
              );
              return;
            }
            ReactRender(
              <div>
                <HasPermission permission="edit_company_own_role">
                  <Button
                    href={`/permission-management/${rowData.name}/${data}/${companyId}`}
                    startIcon={<EditOutlined />}
                  >
                    {t("table.editPermission")}
                  </Button>
                </HasPermission>
                <HasPermission permission="delete_company_own_role">
                  <Button
                    onClick={() =>
                      handleRemoveRoleDialogClickOpen(rowData.id, rowData.name)
                    }
                    color="secondary"
                    startIcon={<DeleteOutlined />}
                  >
                    {t("table.removeRole")}
                  </Button>
                </HasPermission>
              </div>,
              td
            );
          }
        },
        { data: "created_at", visible: false, searchable: false }
      ]
    });
  };

  //Create Role Props and state
  const [createRoleDialogOpen, setCreateRoleDialogOpen] = useState(false);
  const handleCreateRoleDialogClickOpen = () => {
    setCreateRoleDialogOpen(true);
  };
  const handleCreateRoleDialogClose = () => {
    setCreateRoleDialogOpen(false);
    table();
  };

  const handleReloadDataTable = () => {
    table();
  };

  useEffect(() => {
    table();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <Paper
      elevation={0}
      className="fullwidth-table-wrapper reset-margin-top-table"
    >
      <div className={classes.tableHeader}>
        <div>
          <IconButton
            aria-label="reload table"
            className={classes.margin}
            size="small"
            onClick={handleReloadDataTable}
          >
            <ReplayOutlined />
          </IconButton>
          <IconButton
            aria-label="reload table"
            className={classes.margin}
            size="small"
            onClick={handleCreateRoleDialogClickOpen}
          >
            <AddBox />
          </IconButton>
        </div>
      </div>
      <CreateRoleDialog
        companyId={companyId}
        open={createRoleDialogOpen}
        onClose={handleCreateRoleDialogClose}
      />
      <table id="role-management-table" className="mdl-data-table"></table>
      {/* <RemoveRoleDialog
        open={open}
        onClose={handleRemoveRoleDialogClose}
        roleId={roleId}
        roleName={roleName}
      /> */}
    </Paper>
  );
};

export default RoleManagementTable;
